import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api, { formatMoney, toShamsi } from '../utils/api';

export default function LoanDetail() {
  const { id } = useParams();
  const [loan, setLoan] = useState(null);
  const [tab, setTab] = useState('payments');
  const [payForm, setPayForm] = useState({ amount: '', payment_date: new Date().toISOString().split('T')[0], note: '', installment_id: '' });
  const [comment, setComment] = useState('');
  const [contactType, setContactType] = useState('call');
  const [instForm, setInstForm] = useState({ count: '', amount: '', start_date: '' });
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  const load = async () => { const { data } = await api.get(`/loans/${id}`); setLoan(data); };
  useEffect(() => { load(); }, [id]);

  const handlePay = async () => {
    try {
      await api.post(`/loans/${id}/payments`, payForm);
      setPayForm({ amount: '', payment_date: new Date().toISOString().split('T')[0], note: '', installment_id: '' });
      setMsg(''); load();
    } catch (err) { setMsg(err.response?.data?.message || 'خطا'); }
  };

  const handleComment = async () => {
    if (!comment.trim()) return;
    await api.post(`/loans/${id}/comments`, { comment, contact_type: contactType });
    setComment(''); load();
  };

  const handleInstallments = async () => {
    const count = Number(instForm.count);
    const amountPer = Number(loan.remaining_amount) / count;
    const installments = [];
    for (let i = 0; i < count; i++) {
      const d = new Date(instForm.start_date);
      d.setMonth(d.getMonth() + i);
      installments.push({ amount: amountPer.toFixed(2), due_date: d.toISOString().split('T')[0] });
    }
    await api.post(`/loans/${id}/installments`, { installments });
    load();
  };

  if (!loan) return <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>در حال بارگذاری...</div>;

  const pct = loan.total_amount > 0 ? (Number(loan.paid_amount) / Number(loan.total_amount) * 100) : 0;

  return (
    <div>
      <div className="page-header">
        <h1>💳 جزئیات وام</h1>
        <button className="btn btn-outline" onClick={() => navigate('/loans')}>← برگشت</button>
      </div>

      {/* کارت خلاصه */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 20 }}>
          <div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>مشتری</p>
            <p style={{ fontWeight: 700, fontSize: 17 }}>{loan.first_name} {loan.last_name}</p>
            <p style={{ fontSize: 13 }}>📞 {loan.phone || '—'}</p>
            <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>📍 {loan.address || '—'}</p>
          </div>
          <div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>مجموع وام</p>
            <p style={{ fontWeight: 700, fontSize: 20 }}>{formatMoney(loan.total_amount)}</p>
          </div>
          <div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>پرداخت شده</p>
            <p style={{ fontWeight: 700, fontSize: 20, color: 'var(--success)' }}>{formatMoney(loan.paid_amount)}</p>
          </div>
          <div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>باقی</p>
            <p style={{ fontWeight: 700, fontSize: 20, color: 'var(--danger)' }}>{formatMoney(loan.remaining_amount)}</p>
          </div>
          <div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 8 }}>وضعیت</p>
            <span className={`badge ${loan.status === 'paid' ? 'badge-success' : loan.status === 'partial' ? 'badge-warning' : 'badge-danger'}`} style={{ fontSize: 13, padding: '5px 14px' }}>
              {loan.status === 'paid' ? '✓ تسویه' : loan.status === 'partial' ? 'جزئی' : 'فعال'}
            </span>
          </div>
        </div>
        {/* نوار پیشرفت */}
        <div style={{ marginTop: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>
            <span>پیشرفت پرداخت</span><span>{pct.toFixed(0)}%</span>
          </div>
          <div style={{ background: 'var(--bg)', borderRadius: 20, height: 12, overflow: 'hidden' }}>
            <div style={{ width: `${pct}%`, background: pct >= 100 ? 'var(--success)' : 'var(--primary)', height: '100%', borderRadius: 20, transition: 'width 0.4s' }} />
          </div>
        </div>
      </div>

      {/* تب‌ها */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 16, borderBottom: '2px solid var(--border)', paddingBottom: 0 }}>
        {[['payments', '💰 پرداخت‌ها'], ['installments', '📅 اقساط'], ['comments', '📝 یادداشت‌ها']].map(([t, label]) => (
          <button key={t} onClick={() => setTab(t)}
            style={{ background: 'none', border: 'none', padding: '10px 18px', cursor: 'pointer', fontFamily: 'Vazirmatn', fontSize: 14,
              fontWeight: tab === t ? 600 : 400, color: tab === t ? 'var(--primary)' : 'var(--text-muted)',
              borderBottom: tab === t ? '2px solid var(--primary)' : '2px solid transparent', marginBottom: -2 }}>
            {label}
          </button>
        ))}
      </div>

      {/* پرداخت‌ها */}
      {tab === 'payments' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <h3 style={{ marginBottom: 16 }}>ثبت پرداخت جدید</h3>
            {msg && <div className="alert alert-danger">{msg}</div>}
            {loan.installments?.length > 0 && (
              <div className="form-group">
                <label className="form-label">قسط مرتبط (اختیاری)</label>
                <select className="form-control" value={payForm.installment_id} onChange={e => setPayForm({ ...payForm, installment_id: e.target.value })}>
                  <option value="">— پرداخت آزاد —</option>
                  {loan.installments.filter(i => i.status !== 'paid').map(i => (
                    <option key={i.id} value={i.id}>قسط {toShamsi(i.due_date)} — {formatMoney(i.amount)}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="form-group">
              <label className="form-label">مقدار پرداخت (افغانی) *</label>
              <input className="form-control" type="number" value={payForm.amount} onChange={e => setPayForm({ ...payForm, amount: e.target.value })} placeholder={formatMoney(loan.remaining_amount)} />
            </div>
            <div className="form-group">
              <label className="form-label">تاریخ پرداخت</label>
              <input className="form-control" type="date" value={payForm.payment_date} onChange={e => setPayForm({ ...payForm, payment_date: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">یادداشت</label>
              <input className="form-control" value={payForm.note} onChange={e => setPayForm({ ...payForm, note: e.target.value })} />
            </div>
            <button className="btn btn-success" style={{ width: '100%' }} onClick={handlePay}>✅ ثبت پرداخت</button>
          </div>
          <div className="card">
            <h3 style={{ marginBottom: 16 }}>تاریخچه پرداخت‌ها</h3>
            {loan.payments?.length ? loan.payments.map(p => (
              <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <div>
                  <p style={{ fontWeight: 600, color: 'var(--success)' }}>{formatMoney(p.amount)}</p>
                  <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>{toShamsi(p.payment_date)} · {p.user_name}</p>
                  {p.note && <p style={{ fontSize: 12 }}>{p.note}</p>}
                </div>
              </div>
            )) : <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 20 }}>پرداختی ثبت نشده</p>}
          </div>
        </div>
      )}

      {/* اقساط */}
      {tab === 'installments' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <h3 style={{ marginBottom: 16 }}>تعریف اقساط</h3>
            <div style={{ background: 'var(--bg)', padding: 12, borderRadius: 8, marginBottom: 16, fontSize: 13 }}>
              باقی وام: <strong>{formatMoney(loan.remaining_amount)}</strong>
            </div>
            <div className="form-group">
              <label className="form-label">تعداد اقساط</label>
              <input className="form-control" type="number" min="1" max="24" value={instForm.count} onChange={e => setInstForm({ ...instForm, count: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">تاریخ شروع</label>
              <input className="form-control" type="date" value={instForm.start_date} onChange={e => setInstForm({ ...instForm, start_date: e.target.value })} />
            </div>
            {instForm.count && Number(instForm.count) > 0 && (
              <div style={{ background: '#e8f5e9', padding: 12, borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                هر قسط: <strong>{formatMoney(Number(loan.remaining_amount) / Number(instForm.count))}</strong>
              </div>
            )}
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={handleInstallments}>💾 ثبت اقساط</button>
          </div>
          <div className="card">
            <h3 style={{ marginBottom: 16 }}>جدول اقساط</h3>
            {loan.installments?.length ? loan.installments.map((inst, i) => (
              <div key={inst.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <div>
                  <p style={{ fontWeight: 500 }}>قسط {i + 1} — {formatMoney(inst.amount)}</p>
                  <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>سررسید: {toShamsi(inst.due_date)}</p>
                </div>
                <span className={`badge ${inst.status === 'paid' ? 'badge-success' : inst.status === 'overdue' ? 'badge-danger' : 'badge-warning'}`}>
                  {inst.status === 'paid' ? '✓ پرداخت' : inst.status === 'overdue' ? 'عقب' : 'در انتظار'}
                </span>
              </div>
            )) : <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 20 }}>قسطی تعریف نشده</p>}
          </div>
        </div>
      )}

      {/* یادداشت‌ها */}
      {tab === 'comments' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div className="card">
            <h3 style={{ marginBottom: 16 }}>یادداشت تماس جدید</h3>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              {[['call', '📞 تماس'], ['visit', '🚶 مراجعه'], ['message', '💬 پیام'], ['other', '📝 سایر']].map(([t, label]) => (
                <button key={t} className={`btn btn-sm ${contactType === t ? 'btn-primary' : 'btn-outline'}`} onClick={() => setContactType(t)}>{label}</button>
              ))}
            </div>
            <div className="form-group">
              <label className="form-label">یادداشت</label>
              <textarea className="form-control" rows={4} value={comment} onChange={e => setComment(e.target.value)} placeholder="مثلاً: با مشتری تماس گرفتم، گفت هفته آینده پول را می‌آورد..." />
            </div>
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={handleComment}>💾 ثبت یادداشت</button>
          </div>
          <div className="card">
            <h3 style={{ marginBottom: 16 }}>تاریخچه تماس‌ها</h3>
            {loan.comments?.length ? loan.comments.map(c => (
              <div key={c.id} style={{ padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                  <span className="badge badge-info" style={{ fontSize: 11 }}>
                    {c.contact_type === 'call' ? '📞' : c.contact_type === 'visit' ? '🚶' : c.contact_type === 'message' ? '💬' : '📝'}
                    {c.contact_type === 'call' ? ' تماس' : c.contact_type === 'visit' ? ' مراجعه' : c.contact_type === 'message' ? ' پیام' : ' سایر'}
                  </span>
                  <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{toShamsi(c.created_at)} · {c.user_name}</span>
                </div>
                <p style={{ fontSize: 13 }}>{c.comment}</p>
              </div>
            )) : <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 20 }}>یادداشتی ثبت نشده</p>}
          </div>
        </div>
      )}
    </div>
  );
}
